<template>
  <div>
    <template v-if="!edit">
      <span>{{title}}</span>
      <lsIcon  style="cursor:pointer" :type="icon" :size="14" @click.native="changeEdit"/>
    </template>
    <template v-else>
      <a-input :value="value" @change="inputChange" @blur="inputBlur" ref="input" ></a-input>
    </template>
  </div>
</template>
<script>
export default {
  name: 'Ls-change-component',
  props: {
    // 图标更换
    icon: {
      type: String,
      default: 'icon-lsmy-sousou'
    },
    title: {
      type: String
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      edit: false
    }
  },
  methods: {
    changeEdit() {
      this.edit = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    inputChange(e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e)
    },
    inputBlur(e) {
      this.edit = false
      this.$emit('blur', e)
    }
  }
}
</script>
